import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import fetchReports from "report/logic/fetchReports";
const retrieveReportsReferencingDashboard = (dashboardId) => fetch("GET", qualifyUrl(`/plugins/org.graylog.plugins.report/reports/byDashboard/${dashboardId}`));
const isDashboardUsedInReports = async (view) => {
  const reports = await fetchReports();
  const reportIds = await retrieveReportsReferencingDashboard(view.id);
  if ((reportIds == null ? void 0 : reportIds.length) === 1) {
    const reportId = reportIds[0];
    const inaccessibleReport = !reports[reportId];
    const reportTitle = inaccessibleReport ? reportId : `"${reports[reportId].title}"`;
    return window.confirm(
      `One or more widget(s) from the dashboard "${view.title}" are used in ${inaccessibleReport ? "inaccessible " : ""}report ${reportTitle}.

 Do you really want to delete it?`
    );
  }
  if ((reportIds == null ? void 0 : reportIds.length) > 1) {
    const reportTitles = reportIds.map((reportId) => {
      const inAccessibleReport = !reports[reportId];
      const reportTitle = inAccessibleReport ? reportId : `"${reports[reportId].title}"`;
      return `    - ${reportTitle}${inAccessibleReport ? " (not permitted to see title)" : ""}`;
    }).join("\n");
    return window.confirm(
      `One or more widget(s) from the dashboard "${view.title}" are used in reports:
${reportTitles}.

 Do you really want to delete it?`
    );
  }
  return null;
};
export default isDashboardUsedInReports;
